import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, LinearProgress } from '@mui/material';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { CommandPalette } from './CommandPalette';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

export function AppLayout() {
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'surface.canvas' }}>
      <Sidebar />

      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <TopBar />
        <Box component="main" sx={{ flex: 1, minWidth: 0, p: { xs: 2, md: 3 } }}>
          {/* Scoped to the content area so a failing page keeps the shell usable,
              and keyed on the route so navigating away clears the error. */}
          <ErrorBoundary resetKey={location.pathname + location.search}>
            {/* Route chunks are lazily loaded; the bar covers the swap. */}
            <Suspense fallback={<LinearProgress sx={{ mt: -3, mx: -3 }} />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </Box>
      </Box>

      <CommandPalette />
    </Box>
  );
}
